import React, { Component } from 'react';
import { Icon, Dropdown } from 'semantic-ui-react';
import i18n from 'i18next';
import PropTypes from 'prop-types';

export class BookingSelectListMultiple extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    filterName: PropTypes.string.isRequired,
    headerText: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.arrayOf(
      PropTypes.string.isRequired,
    ),
    search: PropTypes.string,
    renderLabel: PropTypes.func,
    selectedText: PropTypes.string,
    label: PropTypes.string,
  }
  static defaultProps = {
    hasSearch: false,
    options: [],
    placeholder: 'Select an Option',
    value: [],
  }
  static getPropsToState = (props) => {
    const value = props.value || [];
    let options = props.options || [];
    const search = props.search || '';
    const limit = props.limit || 0;
    if (limit > 0) {
      options = options.map(d => ({
        disabled: limit > 0 && value.length >= limit,
        ...d,
      }));
    }
    return {
      value,
      options,
      search,
    };
  }
  constructor(props) {
    super(props);
    const state = BookingSelectListMultiple.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = BookingSelectListMultiple.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  handleOnChange = (e, { value }) => {
    if (this.state.value.some(v => v === value)) {
      const index = this.state.value.findIndex(v => v === value);
      this.state.value.splice(index, 1);
    } else {
      this.state.value.push(value);
    }
    const newValue = [].concat(this.state.value);
    this.setState({ value: newValue }, () => {
      this.props.onChange(newValue, this.props.filterName);
    });
  }
  render() {
    const classNames = ['uc-dropdown uc-dropdown-select-list-multiple booking'];
    if (this.state.value.length > 0) {
      classNames.push('selected');
    }
    return (
      <div className="field">
        <label className="ui" htmlFor={this.props.filterName} style={{ fontWeight: 'bold', margin: '0 0 0.28571429rem 0', fontSize: '.92857143em', display: 'block' }}>{this.props.label}</label>
        <Dropdown
          selection
          fluid
          scrolling
          search
          floating
          className={classNames.join(' ')}
          closeOnChange={false}
          header={this.props.headerText}
          onChange={this.handleOnChange}
          options={this.state.options.map(op => ({
            ...op,
            content: (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Icon
                  style={{
                    color: this.state.value.some(v => v === op.value) ? '#50b793' : '#969CA4',
                    flex: '0 0 auto', // prevents icon from stretching
                    marginRight: '8px',
                  }}
                  size="large"
                  inverted
                  name={`square ${this.state.value.some(v => v === op.value) ? 'check' : 'outline'}`}
                />
                <span style={{ flex: 1 }}>{op.text}</span>
              </div>
            ),
          }))}
          renderLabel={this.props.renderLabel}
          selectOnBlur={false}
          text={
            this.state.value.length > 0
            ? `${this.state.value.length} ${this.props.selectedText || 'selected'}` || null
            : this.props.placeholder
          }
          placeholder={this.state.value.length > 0 ? null : this.props.placeholder}
          disabled={this.props.disabled}
          value=""
          name={this.props.filterName}
          noResultsMessage={i18n.t('No results found', { ns: 'translation' })}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UpdatedComponents/UCBookingSelectListMultiple.jsx